<template>
    <v-container fill-height fluid pa-0>
        <v-row align="center" class="fill-height" justify="center">
            <animation :url="'/animations/achievement_confetti_cannon.json'"
                       loop
                       style="position: absolute; height: 500px; top: -50px;"
                       v-if="show"
            ></animation>
            <v-col cols="12" v-if="mode">
                <page-heading :text="$t('general.achievement')"
                              text-center
                ></page-heading>
                <v-row class="my-5" justify="center" no-gutters>
                    <div :style="{width:imageWidth+'px',height:imageWidth+'px'}"
                         id="avatar"
                         style="position:relative; overflow: hidden; border-radius: 50%; box-shadow: 0 0 0 7px rgba(255,255,255,0.2);"
                    >

                      <v-progress-circular :size="imageWidth" color="lightgray" indeterminate v-if="!imageLoaded"
                                           width="1"></v-progress-circular>
                        <img
                            :src="'/img/achievements/achievement_' + mode + '.svg'"
                            :style="{width:size+'px','transform-origin':isCrown?'0% 0%':''}"
                            id="item"
                            ref="crown"
                            style="position: absolute; z-index: 1;"
                        />
                        <canvas ref="canvas"></canvas>
                    </div>
                    <!--<div :style="{width:imageWidth+'px',height:imageWidth+'px'}"
                         id="avatar"
                         style="position:relative;"
                    >
                        <img
                            :src="'/img/achievements/achievement_' + mode + '.svg'"
                            id="item"
                            ref="crown"
                            :style="{width:size+'px'}"
                            style="position: absolute; z-index: 1; transform-origin: 0% 0%;"
                        />
                        <canvas ref="canvas" style="position:absolute; top:0; left:0;"></canvas>
                    </div>-->
                </v-row>
                <v-row justify="center" no-gutters>
                    <div class="title font-weight-light">
                        <slot></slot>
                    </div>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PageHeading from "../../components/framework/PageHeading";
    import Animation from "../display/Animation";
    import {TweenMax} from 'gsap'
    import profilePictureFacePositionMixin from "./profilePictureFacePositionMixin";
    import soundController from "../../lib/soundController";

    export default {
        name: "Achievement",
        components: {
            PageHeading,
            Animation
        },
        mixins: [profilePictureFacePositionMixin],
        data: () => ({
            show: false,
            mode: null,
            size: 0,
            loading: true,
            animation: null,
            timeout:null
        }),
        methods: {
            setMode() {
                let value = Math.random();
                //let value = 0.6;
                if (value < 0.5) {
                    this.mode = 'glasses';
                } else {
                    this.mode = 'crown';
                }
            },
            initiateAchievement() {
                soundController.achievementWithApplause();
                this.loading = false;

                if (!this.faceData) {
                    this.show = true;
                    this.timeout=setTimeout(()=>this.$emit('back'),5000);
                    return;
                }
                this.size = this.faceData.width;
                if (this.isCrown) {
                    this.animateAchievement(this.faceData.left.x, this.faceData.left.y);
                } else {
                    this.animateAchievement(this.faceData.left.x, this.faceData.left.y);
                }
            },
            initialAnimation() {
                TweenMax.set('#item', {x: 0, y: 0, opacity: 0});
               // TweenMax.fromTo('#avatar', 1, {scale: 0.2}, {scale: 1, ease: Elastic.easeOut.config(1, 0.3)});
            },
            animateAchievement(x, y) {
                TweenMax.fromTo('#item', 1, {x: 0, y: 0, opacity: 0}, {
                    left: x,
                    top: y,
                    opacity: 1,
                    rotation: this.faceData.angle
                });
                setTimeout(() => {
                    this.show = true;
                    this.timeout=setTimeout(()=>this.$emit('back'),5000);
                }, 1000)

            }
        },
        mounted() {
            this.setMode();
            this.$nextTick(() => {
                this.initialAnimation();
            });
        },
        beforeDestroy() {
           clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>